import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../util/assets';

const propTypes = {
  className: PropTypes.string,
  position: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  iconPath: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const WaldoSpeechBubble = ({
  className,
  position = 'top',
  iconPath = '/waldo-icon.svg',
  children,
}) => {
  const classes = classNames({
    'waldo-speech-bubble': true,
    [`position-${position}`]: true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <img
        src={getAsset(iconPath)}
        alt=""
        className="waldo-speech-bubble-icon"
      />

      <div className="waldo-speech-bubble-text">{children}</div>
    </div>
  );
};

WaldoSpeechBubble.propTypes = propTypes;

export default WaldoSpeechBubble;
